<template>
  <div class="container-fluid">
    <div class="card shadow-sm">
      <div class="card-header bg-primary text-white">
        <h4><i class="fas fa-sync-alt"></i> Próximas Renovaciones</h4>
      </div>
    </br>
    <div class="card-body">


        <div class="row mb-3">
            <div class="col-md-6">
                <div class="input-group">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Buscar Placa, cliente o fecha..."
                        v-model="busqueda"
                    >
                    <div class="input-group-append">
                        <span class="input-group-text"><i class="fas fa-search"></i></span>
                    </div>
                </div>



            </div>
              <div class="col-md-3 text-right">
                    <button class="btn btn-danger" @click="exportarPDF">
                        <i class="fas fa-file-pdf"></i> Exportar PDF
                    </button>
                </div>
        </div>
     </div>

      <div class="card-body">

        <div class="mb-2">
             <p>Mostrando {{ listaPaginada.length }} de {{ listaFiltrada.length }} registros encontrados.</p>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Póliza #</th>
              <th>Cliente</th>
              <th>Vencimiento</th>
              <th>Meses Faltantes</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="listaPaginada.length === 0">
                <td colspan="5" class="text-center">No se encontraron registros coincidentes.</td>
            </tr>

            <tr v-for="item in listaPaginada" :key="item.id">
              <td>{{ item.placa }}</td>
              <td>{{ item.cliente }}</td>
              <td>{{ item.vigencia_fin }}</td>
              <td>
                <span :class="item.meses_restantes <= 1 ? 'badge badge-danger' : 'badge badge-warning'">
                  {{ item.meses_restantes }} meses
                </span>
              </td>
              <td>
                <button class="btn btn-sm btn-success">Llamar Cliente</button>
              </td>
            </tr>
          </tbody>
        </table>
            <nav aria-label="Page navigation">
                <ul class="pagination">
                    <li class="page-item" :class="{disabled: paginaActual === 1}">
                        <button class="page-link" @click="paginaActual--">Anterior</button>
                    </li>
                    <li class="page-item disabled">
                        <span class="page-link">Página {{ paginaActual }} de {{ totalPaginas }}</span>
                    </li>
                    <li class="page-item" :class="{disabled: paginaActual === totalPaginas}">
                        <button class="page-link" @click="paginaActual++">Siguiente</button>
                    </li>
                </ul>
            </nav>
      </div>
    </div>
  </div>
</template>



<script>


import { jsPDF } from "jspdf/dist/jspdf.umd.min.js";
import autoTable from "jspdf-autotable";

export default {
  data() {
    return {
      lista: [],
      busqueda:'',
      paginaActual: 1,
      elementosPorPagina: 10
    }
  },
  watch: {

    busqueda() {
        this.paginaActual = 1;
    }
},
  computed: {

        listaFiltrada() {
            return this.lista.filter((item) => {

                let textoBusqueda = this.busqueda.toLowerCase();


            let busquedaNumerica = textoBusqueda.replace(/\D/g, '');


            let placa = String(item.placa).toLowerCase();
            let cliente = String(item.cliente).toLowerCase();
             let vigencia_fin = String(item.vigencia_fin).toLowerCase();
            let mesesRestantes = String(item.meses_restantes); // El número tal cual


            let coincideTexto = placa.includes(textoBusqueda) ||  vigencia_fin.includes(textoBusqueda)  ||
                               cliente.includes(textoBusqueda);


            let coincideMeses = busquedaNumerica !== '' && mesesRestantes.includes(busquedaNumerica);


            return coincideTexto || coincideMeses;
            });
        },

        totalPaginas() {
        return Math.ceil(this.listaFiltrada.length / this.elementosPorPagina);
    },
    // 3. Finalmente, cortamos la lista para la página actual
    listaPaginada() {
        let inicio = (this.paginaActual - 1) * this.elementosPorPagina;
        return this.listaFiltrada.slice(inicio, inicio + this.elementosPorPagina);
    }
    },
  mounted() {
    this.obtenerRenovaciones();
  },
  methods: {
    obtenerRenovaciones() {
      let url = '/reporte/renovaciones';
      axios.get(url).then(response => {
        this.lista = response.data;
      }).catch(error => {
        console.error("Error obteniendo renovaciones", error);
      });
    },
    exportarPDF() {
            const doc = new jsPDF();

            // Título del reporte
            doc.text("Reporte de Renovaciones", 14, 15);

            // 2. Preparamos las columnas
            const columnas = ["placa", "Cliente", "vigencia_fin", "Meses Restantes"];

            // 3. Mapeamos la lista filtrada (la que el usuario está viendo)
            const filas = this.listaFiltrada.map(item => [
                item.placa,
                item.cliente,
                item.vigencia_fin,
                item.meses_restantes + " meses"
            ]);

            // 4. Generamos la tabla
          autoTable(doc, {
        startY: 20,
        head: [columnas],
        body: filas,
        theme: 'striped'
    });

            // 5. Descargar
            doc.save('renovaciones.pdf');
        }
  }
}



</script>




